"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var paymentFrequencyStyles_1 = require("./paymentFrequencyStyles");
var ClickableCustomTooltip_1 = require("../../common/ClickableCustomTooltip/ClickableCustomTooltip");
var Close_1 = require("@material-ui/icons/Close");
var Price_1 = require("../../../../../common/components/prices/price/Price");
var PriceDisplayType_1 = require("../../../../../../../../common/enum/PriceDisplayType");
var clsx_1 = require("clsx");
var PaymentFrequency = function (_a) {
    var primaryPrice = _a.primaryPrice, disclaimer = _a.disclaimer, labelAfter = _a.labelAfter, dataTest = _a.dataTest, className = _a.className;
    var style = paymentFrequencyStyles_1.default();
    return (<core_1.Box className={style.paymentFrequencyContainer}>
      <>
        <Price_1.default price={primaryPrice.value} priceDisplayType={PriceDisplayType_1.PriceDisplayType.FINANCE} currency={primaryPrice.currency} className={clsx_1.default([style.priceElement, className])} dataTest={dataTest}/>
        <core_1.Typography className={style.priceElement} component={'span'} data-test={'text:frequency'}>
          &nbsp;{labelAfter}
        </core_1.Typography>
      </>
      <ClickableCustomTooltip_1.default translationId="trans__checkout__vehicle_details__price_with_finance__indicative_repayment" tooltipType={'frequency-open'}>
        <>
          <Close_1.default className={style.tooltipCloseIcon} data-test="common:mui:tooltip:frequency-close-button"/>
          <core_1.Typography className={style.disclaimer} dangerouslySetInnerHTML={{ __html: disclaimer }} data-test="text:repayment:disclaimer"/>
        </>
      </ClickableCustomTooltip_1.default>
    </core_1.Box>);
};
exports.default = PaymentFrequency;
